import apiFetch from '../apiFetch'

export default function (token, finderParams) {
  return apiFetch({
    endPoint: 'Charge/FindByFilterDownload',
    method: 'POST',
    body: finderParams,
    token: token,
    parseBlobAndAssign: true
  })
}
